import script from "./NextProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./NextProduct.vue?vue&type=script&setup=true&lang=js"

import "./NextProduct.vue?vue&type=style&index=0&id=2b7199f7&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b7199f7"]])

export default __exports__